/* Цвета для температуры */
export default async function BackgroundColor(e) {
  const colors = ["#0277bd", "#29b6f6", "#b3e5fc", "#a5d6a7", "#a5d6a7", "#fff59d", "#fdd835", "#ef6c00"];
  const result = [];
  const keys = [-1e6, -20, -10, 0, 10, 20, 30, 1e6];
  const l = keys.length;
  const l2 = e.length;
  for (let j = 0; j < l2; j++) {
    for (let i = 0; i < l; i++) {
      if (e[j] > keys[i] && e[j] <= keys[i + 1]) {
        result.push(colors[i]);
      }
    }
  }
  return result;
}
